/* eslint-disable react/prop-types */
/* eslint-disable no-console */
/* eslint-disable global-require */
/* eslint-disable react/prefer-stateless-function */
import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import { SdfBusyIndicator } from '@waypoint/react-components';
import {
  isLocalStorageSupported,
  getCallingAppId,
  getUrlLocationSearch,
  getParameterCaseInsensitive,
} from '../util/misc';

import { LoginContainer } from '../containers';
import {
  HOME,
  STEP_UP_CHANNELS,
  QUESTION_COLLECTION,
  CHANNEL_COLLECTION,
  MOBILE_COLLECTION,
  LANDLINE_COLLECTION,
  EMAIL_COLLECTION,
  VOICE_BIOMETRICS_COLLECTION,
  GLOBAL_TNC_COLLECTION,
  STEP_UP_VERIFICATION,
  CHANGE_PASSWORD,
  TERMS_AND_CONDITIONS,
  STEP_UP_QNA,
  ERROR_PAGE,
  MOBILE_LIST_PAGE,
  SUCCESS_PAGE,
  FIDO_SETUP_CANCEL_PAGE,
  FIDO_SETUP_ERROR_PAGE,
  FIDO_AUTHENTICATE_SUCCESS,
  MESSAGE_SENT_PAGE,
  FIDO_REGISTER_SUCCESS,
  FIDO_TEXTLINK_PAGE,
  FIDO_DEVICE_REGISTER,
  FIDO_DEVICE_LIST,
} from './router-url-constants';

const ChangePasswordContainer = lazy(
  () => import('../containers/login/changepassword/ChangePasswordContainer'),
);
const ChannelCollectionContainer = lazy(
  () => import('../containers/login/channel-collection/ChannelCollectionContainer'),
);
const MobileCollectionContainer = lazy(
  () => import('../containers/login/channel-collection/MobileCollectionContainer'),
);
const LandlineCollectionContainer = lazy(
  () => import('../containers/login/channel-collection/LandlineCollectionContainer'),
);
const EmailCollectionContainer = lazy(
  () => import('../containers/login/channel-collection/EmailCollectionContainer'),
);
const VoiceBioMetricsCollectionContainer = lazy(
  () => import('../containers/login/channel-collection/VoiceBioMetricsCollectionContainer'),
);
const GlobalTNCCollectionContainer = lazy(
  () => import('../containers/login/channel-collection/GlobalTNCCollectionContainer'),
);
const QuestionCollectionContainer = lazy(
  () => import('../containers/login/question-collection/QuestionCollectionContainer'),
);
const ErrorPageContainer = lazy(
  () => import('../containers/login/error/ErrorPageContainer'),
);
const CommonDisplayPageContainer = lazy(
  () => import('../containers/login/common-display/CommonDisplayPageContainer'),
);
const TCContainer = lazy(
  () => import('../containers/login/terms-and-conditions/TCContainer'),
);
const ChannelListContainer = lazy(
  () => import('../containers/login/step-up/ChannelListContainer'),
);
const OTPContainer = lazy(
  () => import('../containers/login/step-up/OTPContainer'),
);
const QNAContainer = lazy(
  () => import('../containers/login/step-up/QNAContainer'),
);
const MobileListContainer = lazy(
  () => import('../containers/login/otp-pwdless/MobileListContainer'),
);

const loading = (
  <SdfBusyIndicator
    size="xl"
    class="flex items-center justify-center h-full p-8 flex-col gap-8 relative"
  />
);

class Routes extends React.Component {
  componentDidMount() {
    window.onpopstate = () => {
      const { redirectURL } = this.props;

      redirectURL(`${HOME}/${getUrlLocationSearch()}`);
    };

    const callingAppId = getCallingAppId().toUpperCase();

    if (
      window.env
      && (window.env.DISABLE_GLANCE_COBROWSE
        ? window.env.DISABLE_GLANCE_COBROWSE === 'false'
          || window.env.DISABLE_GLANCE_COBROWSE === false
        : true)
      && ((window.env.COBROWSE_APPLIST !== undefined
        && window.env.COBROWSE_APPLIST.indexOf(callingAppId) !== -1)
        || window.env.COBROWSE_APPLIST === undefined)
    ) {
      import('../util/html/fetchIndexHtmlResources')
        .then(({ loadCobrowse }) => {
          loadCobrowse();
        })
        .catch((err) => console.log(`Could not run de html scripts ${err}`));
    }
  }

  render() {
    const { apiSessionSubmit, userid } = this.props;

    let userData = {};

    let isFidoUser;

    if (isLocalStorageSupported(true)) {
      userData = localStorage.getItem('userData') || '{}';

      userData = JSON.parse(userData);
      userData[userid] = getParameterCaseInsensitive(userData, userid) || {};
      userData[userid] = userData[userid] || {};
      userData[userid].fido2 = userData[userid].fido2 || {};
      isFidoUser = userData[userid].fido2.localCredentials;
    }
    const identifyValidUser = apiSessionSubmit || isFidoUser;
    const changePasswordRules = [identifyValidUser];
    const validatedUser = checkValidation(changePasswordRules);

    return (
      <Suspense fallback={ loading }>
        <RouterRoutes>
          <Route
            path={ HOME }
            element={ <LoginContainer { ...this.props } /> }
          />
          <Route
            path={ MOBILE_LIST_PAGE }
            element={ (
              <ProtectedRoute
                element={ <MobileListContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ FIDO_TEXTLINK_PAGE }
            element={ (
              <ProtectedRoute
                element={ <MobileListContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ FIDO_DEVICE_LIST }
            element={ (
              <ProtectedRoute
                element={ <MobileListContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ FIDO_DEVICE_REGISTER }
            element={ (
              <ProtectedRoute
                element={ <CommonDisplayPageContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ SUCCESS_PAGE }
            element={ (
              <ProtectedRoute
                element={ <CommonDisplayPageContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ FIDO_REGISTER_SUCCESS }
            element={ (
              <ProtectedRoute
                element={ <CommonDisplayPageContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ FIDO_SETUP_CANCEL_PAGE }
            element={ (
              <ProtectedRoute
                element={ <CommonDisplayPageContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ FIDO_SETUP_ERROR_PAGE }
            element={ (
              <ProtectedRoute
                element={ <CommonDisplayPageContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ FIDO_AUTHENTICATE_SUCCESS }
            element={ (
              <ProtectedRoute
                element={ <CommonDisplayPageContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ MESSAGE_SENT_PAGE }
            element={ (
              <ProtectedRoute
                element={ <CommonDisplayPageContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ STEP_UP_CHANNELS }
            element={ (
              <ProtectedRoute
                element={ <ChannelListContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ QUESTION_COLLECTION }
            element={ (
              <ProtectedRoute
                element={ <QuestionCollectionContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ CHANNEL_COLLECTION }
            element={ (
              <ProtectedRoute
                element={ <ChannelCollectionContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ MOBILE_COLLECTION }
            element={ (
              <ProtectedRoute
                element={ <MobileCollectionContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ LANDLINE_COLLECTION }
            element={ (
              <ProtectedRoute
                element={ <LandlineCollectionContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ EMAIL_COLLECTION }
            element={ (
              <ProtectedRoute
                element={ <EmailCollectionContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ VOICE_BIOMETRICS_COLLECTION }
            element={ (
              <ProtectedRoute
                element={ <VoiceBioMetricsCollectionContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ GLOBAL_TNC_COLLECTION }
            element={ (
              <ProtectedRoute
                element={ <GlobalTNCCollectionContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ STEP_UP_VERIFICATION }
            element={ (
              <ProtectedRoute
                element={ <OTPContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ CHANGE_PASSWORD }
            element={ (
              <ProtectedRoute
                element={ <ChangePasswordContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ TERMS_AND_CONDITIONS }
            element={ (
              <ProtectedRoute
                element={ <TCContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ STEP_UP_QNA }
            element={ (
              <ProtectedRoute
                element={ <QNAContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path={ ERROR_PAGE }
            element={ (
              <ProtectedRoute
                element={ <ErrorPageContainer { ...this.props } /> }
                loggedIn={ validatedUser }
              />
            ) }
          />
          <Route
            path="*"
            element={ (
              <Navigate
                to={ HOME }
                replace
              />
) }
          />
        </RouterRoutes>
      </Suspense>
    );
  }
}

export function ProtectedRoute({ element, loggedIn }) {
  return loggedIn ? (
    element
  ) : (
    <Navigate
      to={ `${HOME}/${getUrlLocationSearch()}` }
      replace
    />
  );
}

const checkValidation = (rules) => {
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < rules.length; i++) {
    if (!rules[i]) {
      return false;
    }
  }
  return true;
};
Routes.propTypes = {
  apiSessionSubmit: PropTypes.string,
  userid: PropTypes.string,
  redirectURL: PropTypes.func,
};

export default Routes;
